/**
 * @legacy
 * @prev core/templates/{base_css.html, base_js.html}
 */
import '../../ui/legacy/common'

import 'select2/select2'
import 'jquery.formset/src/jquery.formset'
import Alpine from 'alpinejs'

import '../../ui/legacy/css/forms.css'
import '../../ui/legacy/css/simple.css'

import './css/signup.css'

import 'select2/select2.css'
import '../../ui/legacy/css/select2.css'


Alpine.start()

document.addEventListener('DOMContentLoaded', async () => {
  const flags = JSON.parse(document.body.dataset.flags)

  /**
   * @legacy
   * @prev core/templates/core/billing_popin.html
   */
  flags.askProof && await import('../../ui/legacy/billing.js')
})

$(document).ready(function() {
  $('select:not(#id_country)').removeClass('form-control').select2({
    minimumResultsForSearch: Infinity
  });
  $('#id_country').removeClass('form-control').select2();
});

